import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ChevronDown } from 'lucide-react';

const locations = [
    'Los Alcázares', 'La Roda Golf', 'Mar Menor Resort', 'Santa Rosalía Resort','Torre Pacheco','La Manga Club','La Manga del Mar Menor',
    'San Javier', 'San Pedro del Pinatar', 'Lo Pagán', 'Santiago de la Ribera',
    'Mil Palmeras', 'Pilar de la Horadada' ,'Torre de la Horadada','Orihuela Costa', 'Cabo Roig',
    'Los Nietos', 'Los Urrutias', 'Cabo de Palos',
];

const PinIcon = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
        <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" fill="#d89d37" />
    </svg>
);

const ServiceArea: React.FC = () => {
    const { t } = useTranslation();
    const [showAll, setShowAll] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    const [isExpanding, setIsExpanding] = useState(false);

    // Detect mobile screen size
    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth < 768);
        };

        checkMobile();
        window.addEventListener('resize', checkMobile);

        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    const handleShowMore = () => {
        setIsExpanding(true);
        setTimeout(() => {
            setShowAll(true);
        }, 300);
    };

    const visibleLocations = isMobile && !showAll ? locations.slice(0, 6) : locations;

    return (
        <div className="container">
            <div className="center-title">
                <span className="sub-title">{t('serviceArea.subtitle')}</span>
                <h2 className="h2-title">{t('serviceArea.title')}</h2>
                <p className="service-area-desc">{t('serviceArea.specialCoverage')}</p>
            </div>

            <div className="service-locations-grid">
                {visibleLocations.map((loc) => (
                    <div className="service-location-chip" key={loc}>
                        <PinIcon />
                        <span>{loc}</span>
                    </div>
                ))}
            </div>

            {isMobile && !showAll && (
                <div
                    className={`show-more-btn-wrapper ${isExpanding ? 'hiding' : ''}`}
                    style={{ textAlign: 'center', marginTop: '30px' }}
                >
                    <button
                        onClick={handleShowMore}
                        className="sec-btn"
                        style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '8px',
                        }}
                    >
                        <span>Show More</span>
                        <ChevronDown size={18} />
                    </button>
                </div>
            )}
        </div>
    );
};

export default ServiceArea;